export default {"src":"/_next/static/media/where-am-i.dfd3db47.gif","height":270,"width":480,"blurWidth":0,"blurHeight":0};